import { render } from "./Required.vue?vue&type=template&id=fdb9c4e4"
import script from "./Required.vue?vue&type=script&lang=js"
export * from "./Required.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__